import { SearchIcon } from "app/components/Icons";
import Input from "app/components/Input";
import Pill from "app/components/Pill";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "app/components/Popover";
import { ITags } from "app/containers/Features/components/CommonTagSelection/types";
import clsx from "clsx";
import React, { useState } from "react";
import { createTransparentColor } from "utils/helpers";

interface Props {
  tags: ITags[];
  visibleCount?: number;
  className?: string;
}

const TagsPreview: React.FC<Props> = ({
  tags,
  visibleCount = 3,
  className,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const renderTag = ({ _id, color, title }: ITags) => {
    const background = createTransparentColor(color, 0.3);
    return (
      <Pill
        key={_id}
        backgroundColor={background}
        name={title?.length > 6 ? `${title.slice(0, 7)}...` : title}
        className={clsx(
          "px-[6px] py-[2px] text-[10px] leading-[18px] font-medium max-w-[80px]",
        )}
      />
    );
  };
  const [search, setSearch] = useState("");

  function searchFilters(tags: ITags[], keyword: string): ITags[] {
    if (!keyword || !tags) {
      return tags ? tags : [];
    }
    const lowerCaseKeyword = keyword.toLowerCase();

    return tags?.filter((tag) => {
      return tag.title.toLowerCase().includes(lowerCaseKeyword);
    });
  }

  const visibleTags = tags.slice(0, visibleCount);
  const remainingTags = tags.slice(visibleCount);
  const remainingCount = remainingTags.length;

  const filteredTags = searchFilters(remainingTags, search);

  if (!tags.length)
    return (
      <span className={clsx(" text-black font-medium text-sm ", className)}>
        No tags
      </span>
    );
  return (
    <div className={clsx("flex gap-1", className)}>
      {visibleTags.map(renderTag)}
      {remainingCount > 0 && (
        <Popover open={isOpen} onOpenChange={setIsOpen}>
          <PopoverTrigger asChild>
            <div className="px-[6px] py-[2px] flex items-center justify-center rounded bg-secondary text-white text-[9px] font-medium">
              +{remainingCount}
            </div>
          </PopoverTrigger>
          <PopoverContent
            align="center"
            className="w-64 bg-white border border-gray-100 !p-0 !py-2 "
          >
            <div className=" flex flex-col gap-1 ">
              <Input
                containerClassName="px-2 pb-1 border-b border-gray-100 "
                id="search"
                placeholder="Search by tag name"
                value={search}
                onChange={(e) => {
                  e.stopPropagation();
                  setSearch(e.target.value);
                }}
                icon={<SearchIcon size="17" />}
                noBorder
                autoFocus={false}
              />
              <div className="overflow-auto max-h-[280px]">
                {filteredTags?.map((opt) => {
                  return (
                    <div className=" px-4 py-3 flex items-center justify-between gap-2 w-full group">
                      <Pill
                        backgroundColor={opt?.color}
                        name={opt?.title}
                        className="px-[6px] py-[2px] text-[10px] leading-[18px] font-medium max-w-[80%]"
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </PopoverContent>
        </Popover>
      )}
    </div>
  );
};

export default TagsPreview;
